/**
 * @module Core
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */
/* tslint:disable:max-line-length max-file-line-count*/ // API const file
// The solution discussed in the call of using `` is not working on breaking api endpoints to different line

/**
 * API Map for resolving API endpoints
 * @access public - global
 */
/*****************************************************************
 * TAG MIGRATION FILE
 * 
 * This file manages the TAG endpoints that will permanently replace the APIGEE endpoints expected to be retired by the end of 2024
 * 
 * TODO: This file is meant to replace src/app/core/api/proxies/assisted-api-endpoints.ts once the migration is complete
 *****************************************************************/
export const ASSISTED_API_MAP = {
  /******************************************************************************
   * ProxyName: retailStore
   * Number of Endpoints: 14
   * Endpoints: API_2700_getRetailStores, API_2708_closeRetailStoresTill, API_2710_closeRetailStores, API_226_postRetailStores, API_2711_openRetailStores, API_227_postRetailStoresTill, API_2707_openRetailStoresTill, API_2709_endOfDayBalance, API_2712_postNoSale, API_2701_getNetworkCashDrawer, API_2702_postOpenCashDrawer, API_2718_setTempStoreAddress, API_2717_getTempStoreAddress, API_2719_updateTempStoreAddressStatus
   ******************************************************************************/
  // Implementations:
  // Services: experience/shop/order-payment/instore-order-payment/services/instore-order-payment.service.ts, support/store/services/change-store-location.service.ts, support/store/services/store.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2700_getRetailStores: {
    domain: 'TAGEndpoint',
    name: 'API_2700_getRetailStores',
    proxyName: 'retailStore',
    url: 'self-service-tpp-retailStore/v1/stores',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Services: support/store/services/store.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2708_closeRetailStoresTill: {
    domain: 'TAGEndpoint',
    name: 'API_2708_closeRetailStoresTill',
    proxyName: 'retailStore',
    url: 'self-service-tpp-retailStore/v1/stores/{storeId}/close-till',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Services: support/store/services/store.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2710_closeRetailStores: {
    domain: 'TAGEndpoint',
    name: 'API_2710_closeRetailStores',
    proxyName: 'retailStore',
    url: 'self-service-tpp-retailStore/v1/stores/{storeId}/close-store',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_226_postRetailStores: {
    domain: 'TAGEndpoint',
    name: 'API_226_postRetailStores',
    proxyName: 'retailStore',
    url: 'self-service-tpp-retailStore/v1/stores/{storeId}/open-close-store',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Services: support/store/services/store.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2711_openRetailStores: {
    domain: 'TAGEndpoint',
    name: 'API_2711_openRetailStores',
    proxyName: 'retailStore',
    url: 'self-service-tpp-retailStore/v1/stores/{storeId}/open-store ',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Services: support/store/services/store.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_227_postRetailStoresTill: {
    domain: 'TAGEndpoint',
    name: 'API_227_postRetailStoresTill',
    proxyName: 'retailStore',
    url: 'self-service-tpp-retailStore/v1/retail-store/v1/stores/{storeId}/open-close-till',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Services: support/store/services/store.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2707_openRetailStoresTill: {
    domain: 'TAGEndpoint',
    name: 'API_2707_openRetailStoresTill',
    proxyName: 'retailStore',
    url: 'self-service-tpp-retailStore/v1/stores/{storeId}/Open-till',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Services: support/store/services/store.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2709_endOfDayBalance: {
    domain: 'TAGEndpoint',
    name: 'API_2709_endOfDayBalance',
    proxyName: 'retailStore',
    url: 'self-service-tpp-retailStore/v1/store/{storeId}',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Services: support/store/services/store.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2712_postNoSale: {
    domain: 'TAGEndpoint',
    name: 'API_2712_postNoSale',
    proxyName: 'retailStore',
    url: 'self-service-tpp-retailStore/v1/stores/{storeId}/no-sale',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Services: experience/shop/order-payment/instore-order-payment/services/instore-order-payment.service.ts, support/payment/instore-payment/services/instore-payment.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2701_getNetworkCashDrawer: {
    domain: 'TAGEndpoint',
    name: 'API_2701_getNetworkCashDrawer',
    proxyName: 'retailStore',
    url: 'self-service-tpp-retailStore/v1/stores/{storeId}/cash-drawer',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Services: support/store/services/store.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2702_postOpenCashDrawer: {
    domain: 'TAGEndpoint',
    name: 'API_2702_postOpenCashDrawer',
    proxyName: 'retailStore',
    url: 'self-service-tpp-retailStore/v1/utility/open-cash-drawer',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Services: support/store/services/store.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2718_setTempStoreAddress: {
    domain: 'TAGEndpoint',
    name: 'API_2718_setTempStoreAddress',
    proxyName: 'retailStore',
    url: 'self-service-tpp-retailStore/v1/setTempStoreAddress',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Services: support/store/services/store.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2717_getTempStoreAddress: {
    domain: 'TAGEndpoint',
    name: 'API_2717_getTempStoreAddress',
    proxyName: 'retailStore',
    url: 'self-service-tpp-retailStore/v1/getTempStoreAddress',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Services: support/store/services/store.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2719_updateTempStoreAddressStatus: {
    domain: 'TAGEndpoint',
    name: 'API_2719_updateTempStoreAddressStatus',
    proxyName: 'retailStore',
    url: 'self-service-tpp-retailStore/v1/updateTempStoreAddressStatus',
    is_tag_proxy: true,
    // Reachability: unreachable
  },


  /******************************************************************************
   * ProxyName: assistedAuth
   * Number of Endpoints: 4
   * Endpoints: API_233_postRepVerification, API_998_getRepProfilePermissions, API_2012_PostRetailRepVerification, API_2218_postManagerOverrideRequest
   ******************************************************************************/
  // Implementations:
  // Services: support/shared/services/override-modal.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_233_postRepVerification: {
    domain: 'TAGEndpoint',
    name: 'API_233_postRepVerification',
    proxyName: 'assistedAuth',
    url: 'self-service-tpp-assistedAuth/v1/rep-verification',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_998_getRepProfilePermissions: {
    domain: 'TAGEndpoint',
    name: 'API_998_getRepProfilePermissions',
    proxyName: 'assistedAuth',
    url: 'self-service-tpp-assistedAuth/v1/permission/rep-profile-permission',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2012_PostRetailRepVerification: {
    domain: 'TAGEndpoint',
    name: 'API_2012_PostRetailRepVerification',
    proxyName: 'assistedAuth',
    url: 'self-service-tpp-assistedAuth/v1/rep-verification',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Services: experience/one-time-pin/services/one-time-pin.service.ts, support/cart-support/services/cart-support.service.ts
  // Components: support/shared/widgets/components/permission-override-modal/permission-override-modal.component.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts, experience/shop/cart/instore-cart/validate-modal/validate-modal.component.ts
  API_2218_postManagerOverrideRequest: {
    domain: 'TAGEndpoint',
    name: 'API_2218_postManagerOverrideRequest',
    proxyName: 'assistedAuth',
    url: 'self-service-tpp-assistedAuth/v1/managerOverride',
    is_tag_proxy: true,
    // Reachability: unreachable
  },


  /******************************************************************************
   * ProxyName: retailStoreReports
   * Number of Endpoints: 6
   * Endpoints: API_262_getPriceOverrideReport, API_264_getReturnsReport, API_2713_postAssignTerminalToStore, API_2720_systematicPostVoidReport, API_540_getReports, API_2706_getReports
   ******************************************************************************/
  // Implementations:
  // Components: experience/store-operations/components/print-reports/daily-reports/price-override-report/price-override-report.component.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_262_getPriceOverrideReport: {
    domain: 'TAGEndpoint',
    name: 'API_262_getPriceOverrideReport',
    proxyName: 'retailStoreReports',
    url: 'self-service-tpp-retailStoreReports/v1/store/{storeId}/reports',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Components: experience/store-operations/components/print-reports/daily-reports/return-report/return-report.component.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_264_getReturnsReport: {
    domain: 'TAGEndpoint',
    name: 'API_264_getReturnsReport',
    proxyName: 'retailStoreReports',
    url: 'self-service-tpp-retailStoreReports/v1/store/{storeId}/reports',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Services: support/store/services/change-store-location.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2713_postAssignTerminalToStore: {
    domain: 'TAGEndpoint',
    name: 'API_2713_postAssignTerminalToStore',
    proxyName: 'retailStoreReports',
    url: 'self-service-tpp-retailStoreReports/v1/stores/assign-terminal-to-store',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Components: experience/store-operations/components/print-reports/daily-reports/systematic-post-void/systematic-post-void.component.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2720_systematicPostVoidReport: {
    domain: 'TAGEndpoint',
    name: 'API_2720_systematicPostVoidReport',
    proxyName: 'retailStoreReports',
    url: 'self-service-tpp-retailStoreReports/v1/reports/systematic-post-void',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Components: experience/store-operations/components/daily-register-summary-till-report/daily-register-summary-till-report.component.ts, experience/store-operations/components/print-reports/daily-reports/post-void/post-void.component.ts, experience/store-operations/components/print-reports/daily-reports/reprinted-receipt/reprinted-receipt.component.ts, experience/store-operations/components/print-reports/daily-reports/summary-report/summary-report.component.ts, experience/store-operations/components/print-reports/management-reports/closing-details-report/closing-details-report.component.ts, experience/store-operations/components/print-reports/management-reports/daily-register-cash/daily-register-cash.component.ts, experience/store-operations/components/print-reports/management-reports/daily-register-summary/daily-register-summary.component.ts, experience/store-operations/components/print-reports/management-reports/deposit-report/deposit-report.component.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_540_getReports: {
    domain: 'TAGEndpoint',
    name: 'API_540_getReports',
    proxyName: 'retailStoreReports',
    url: 'self-service-tpp-retailStoreReports/v1/store/{storeId}/reports',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Components: experience/store-operations/components/print-reports/daily-reports/daily-handset-contract/daily-handset-contract.component.ts, experience/store-operations/components/print-reports/on-demand-reports/daily-inventory/daily-inventory.component.ts, experience/store-operations/components/print-reports/on-demand-reports/daily-transaction-audit/daily-transaction-audit.component.ts, experience/store-operations/components/print-reports/on-demand-reports/debit-credit-card-reconciliation/debit-credit-card-reconciliation.component.ts, experience/store-operations/components/print-reports/shared/daily-shared-report/daily-shared-report.component.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2706_getReports: {
    domain: 'TAGEndpoint',
    name: 'API_2706_getReports',
    proxyName: 'retailStoreReports',
    url: 'self-service-tpp-retailStoreReports/v1/store/{storeId}/reports',
    is_tag_proxy: true,
    // Reachability: unreachable
  },


  /******************************************************************************
   * ProxyName: assistedPurchasePathReturn
   * Number of Endpoints: 3
   * Endpoints: API_302_getSuggestedExchangeProducts, API_2911_getWarrantyExchange, API_2912_getDeviceStaticData
   ******************************************************************************/
  // Implementations:
  // Services: experience/warranty-replacement/services/warranty-replacement.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_302_getSuggestedExchangeProducts: {
    domain: 'TAGEndpoint',
    name: 'API_302_getSuggestedExchangeProducts',
    proxyName: 'assistedPurchasePathReturn',
    url: 'self-service-tpp-assistedPurchasePathReturn/v1/products/exchange-product',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Services: experience/landing/common/services/line-landing.service.ts, experience/warranty-exchange-summary/services/warranty-exchange-summary.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2911_getWarrantyExchange: {
    domain: 'TAGEndpoint',
    name: 'API_2911_getWarrantyExchange',
    proxyName: 'assistedPurchasePathReturn',
    url: 'self-service-tpp-assistedPurchasePathReturn/v1/warranty-exchange',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Services: experience/warranty-exchange-summary/services/warranty-exchange-summary.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2912_getDeviceStaticData: {
    domain: 'TAGEndpoint',
    name: 'API_2912_getDeviceStaticData',
    proxyName: 'assistedPurchasePathReturn',
    url: 'self-service-tpp-assistedPurchasePathReturn/v1/getDeviceStaticData',
    is_tag_proxy: true,
    // Reachability: unreachable
  },


  /******************************************************************************
   * ProxyName: assistedLookup
   * Number of Endpoints: 6
   * Endpoints: API_320_getSearchCustomers, API_321_getSearchOrders, API_2032_postSpecialInstructions, API_2047_getSpecialInstructionsType, API_2212_postValidateTempPin, API_2213_postGenerateTempPin
   ******************************************************************************/
  // Implementations:
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_320_getSearchCustomers: {
    // twbdom-assisted-lookup
    // GET
    // Onboarded
    domain: 'TAGEndpoint',
    name: 'API_320_getSearchCustomers',
    proxyName: 'assisted-lookup',
    url: 'self-service-tpp-assisted-lookup/v1/customers/search',
    is_tag_proxy: true
  },

  // Implementations:
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_321_getSearchOrders: {
    domain: 'TAGEndpoint',
    name: 'API_321_getSearchOrders',
    proxyName: 'assisted-lookup',
    url: 'self-service-tpp-assisted-lookup/v1/orders/search',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Services: support/shared/services/user.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2032_postSpecialInstructions: {
    domain: 'TAGEndpoint',
    name: 'API_2032_postSpecialInstructions',
    proxyName: 'assisted-lookup',
    url: 'self-service-tpp-assisted-lookup/v1/customers/accounts/special-instructions',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Services: support/shared/services/user.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2047_getSpecialInstructionsType: {
    domain: 'TAGEndpoint',
    name: 'API_2047_getSpecialInstructionsType',
    proxyName: 'assisted-lookup',
    url: 'self-service-tpp-assisted-lookup/v1/customers/accounts/special-instructions-types',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Services: experience/one-time-pin/services/one-time-pin.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2212_postValidateTempPin: {
    // twbdom-assisted-lookup
    // POST
    // Onboarded
    domain: 'TAGEndpoint',
    proxyName: 'assisted-lookup',
    name: 'API_2212_postValidateTempPin',
    url: 'self-service-tpp-assisted-lookup/v1/validateTempPin',
    is_tag_proxy: true
  },

  // Implementations:
  // Services: experience/one-time-pin/services/one-time-pin.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2213_postGenerateTempPin: {
    // twbdom-assisted-lookup
    // POST
    // Onboarded
    domain: 'TAGEndpoint',
    proxyName: 'assisted-lookup',
    name: 'API_2213_postGenerateTempPin',
    url: 'self-service-tpp-assisted-lookup/v1/generateTempPin',
    is_tag_proxy: true
  },


  /******************************************************************************
   * ProxyName: 
   * Number of Endpoints: 4
   * Endpoints: API_324_getAccountDetails, API_2110_getCompatibleAccessories, API_2605_overridePayment, API_2800_getProfileDetails
   ******************************************************************************/
  // Implementations:
  // Services: experience/apply-credit/services/apply-credit.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_324_getAccountDetails: {
    domain: 'TAGEndpoint',
    name: 'API_324_getAccountDetails',
    proxyName: '',
    url: 'self-service-tpp-/v1/assisted-customer-support/v1/customers/{customerId}/accounts/{accountId}',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Components: experience/shop/product-selector/components/accessory-product-offerings/accessory-product-offerings.component.ts, experience/shop/shared-browse/components/product-carousel/product-carousel.component.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2110_getCompatibleAccessories: {
    domain: 'TAGEndpoint',
    name: 'API_2110_getCompatibleAccessories',
    proxyName: '',
    url: 'self-service-tpp-/v1/v2/products/{productId}/relationships',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Services: support/shared/services/override-modal.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2605_overridePayment: {
    domain: 'TAGEndpoint',
    name: 'API_2605_overridePayment ',
    proxyName: '',
    url: 'self-service-tpp-/v1/v2/carts/{cartId}/payments/override-payment',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Services: experience/shop/cart/modules/account-setup/services/account-setup.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2800_getProfileDetails: {
    domain: 'TAGEndpoint',
    name: 'API_2800_getProfileDetails',
    proxyName: '',
    url: 'self-service-tpp-/v1/v2/profiles',
    is_tag_proxy: true,
    // Reachability: unreachable
  },


  /******************************************************************************
   * ProxyName: assistedReferenceList
   * Number of Endpoints: 2
   * Endpoints: API_326_getAdjustmentReasons, API_2044_getReasons
   ******************************************************************************/
  // Implementations:
  // Services: experience/usage-details/services/usage-details.service.ts, support/store/services/store.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts, experience/device-assessment/service/device-assessment.service.ts, experience/order-summary/service/order-summary.service.ts
  API_326_getAdjustmentReasons: {
    domain: 'TAGEndpoint',
    name: 'API_326_getAdjustmentReasons',
    proxyName: 'assisted-reference-list',
    url: 'self-service-tpp-assisted-reference-list/v1/reference-list/reasons',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Services: experience/cancel-line/services/cancel-line.service.ts, support/cart-support/services/cart-support.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts, experience/device-assessment/service/device-assessment.service.ts, experience/imei-check/imei-check.service.ts
  API_2044_getReasons: {
    domain: 'TAGEndpoint',
    name: 'API_2044_getReasons',
    proxyName: 'assisted-reference-list',
    url: 'self-service-tpp-assisted-reference-list/v1/reference-list/reasons',
    is_tag_proxy: true,
    // Reachability: unreachable
  },


  /******************************************************************************
   * ProxyName: caseMgmt
   * Number of Endpoints: 7
   * Endpoints: API_329_postCustomerRequests, API_2204_fraudRoutingRequest, API_2202_postNegativeFileRequest, API_2203_postAdjustCharge, API_2205_missingPaymentRequest, API_2206_postReturnPaymentDispute, API_2221_postGeneralInquiryTicket
   ******************************************************************************/
  // Implementations:
  // Services: support/shared/services/override-modal.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_329_postCustomerRequests: {
    // twbdom-case-mgmt
    // POST
    // Onboarded
    domain: 'TAGEndpoint',
    name: 'API_329_postCustomerRequests',
    proxyName: 'caseMgmt',
    url: 'self-service-tpp-case-mgmt/v1/applyCredit',
    is_tag_proxy: true
  },

  // Implementations:
  // Services: support/fraud-check/services/fraud-check.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2204_fraudRoutingRequest: {
    domain: 'TAGEndpoint',
    name: 'API_2204_fraudRoutingRequest',
    proxyName: 'caseMgmt',
    url: 'self-service-tpp-caseMgmt/v1/fraudRoutingRequest',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Services: experience/negative-file-request/services/negative-file-request.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2202_postNegativeFileRequest: {
    // twbdom-case-mgmt
    // POST
    // Onboarded
    domain: 'TAGEndpoint',
    name: 'API_2202_postNegativeFileRequest',
    proxyName: 'caseMgmt',
    url: 'self-service-tpp-case-mgmt/v1/negativeFileRequest',
    is_tag_proxy: true
  },

  // Implementations:
  // Services: experience/billing-details/services/adjust-charges.service.ts
  // Components: experience/billing-details/components/adjust-charges/adjust-charges.component.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2203_postAdjustCharge: {
    // twbdom-case-mgmt
    // POST
    // Onboarded
    domain: 'TAGEndpoint',
    name: 'API_2203_postAdjustCharge',
    proxyName: 'caseMgmt',
    url: 'self-service-tpp-case-mgmt/v1/adjustCharge',
    is_tag_proxy: true
  },

  // Implementations:
  // Services: experience/billing-landing/services/missing-payment-request.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2205_missingPaymentRequest: {
    // twbdom-case-mgmt
    // POST
    // Onboarded
    domain: 'TAGEndpoint',
    name: 'API_2205_missingPaymentRequest',
    proxyName: 'caseMgmt',
    url: 'self-service-tpp-case-mgmt/v1/missingPaymentRequest',
    is_tag_proxy: true
  },

  // Implementations:
  // Services: experience/billing-landing/services/return-payment-dispute.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2206_postReturnPaymentDispute: {
    // twbdom-case-mgmt
    // POST
    // Onboarded
    domain: 'TAGEndpoint',
    name: 'API_2206_postReturnPaymentDispute',
    proxyName: 'caseMgmt',
    url: 'self-service-tpp-case-mgmt/v1/returnPaymentDispute',
    is_tag_proxy: true
  },

  // Implementations:
  // Other files: core/api/proxies/assisted-api-endpoints.ts, experience/general-inquiry/service/general-inquiry.service.ts
  API_2221_postGeneralInquiryTicket: {
    domain: 'TAGEndpoint',
    name: 'API_2221_postGeneralInquiryTicket',
    proxyName: 'caseMgmt',
    url: 'self-service-tpp-caseMgmt/v1/generalInquiryTicket',
    is_tag_proxy: true,
    // Reachability: unreachable
  },


  /******************************************************************************
   * ProxyName: assistedCustomerSupport
   * Number of Endpoints: 2
   * Endpoints: API_329_postMissingPayment, API_394_postDeviceDetails
   ******************************************************************************/
  // Implementations:
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_329_postMissingPayment: {
    domain: 'TAGEndpoint',
    name: 'API_329_postMissingPayment',
    proxyName: 'assistedCustomerSupport',
    url: 'self-service-tpp-assistedCustomerSupport/v1/customers/{customerId}/accounts/{accountId}/requests',
    clearCache: true,
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_394_postDeviceDetails: {
    domain: 'TAGEndpoint',
    name: 'API_394_postDeviceDetails',
    proxyName: 'assistedCustomerSupport',
    url: 'self-service-tpp-assistedCustomerSupport/v1/customers/{customerId}/devices',
    is_tag_proxy: true,
    // Reachability: unreachable
  },


  /******************************************************************************
   * ProxyName: customerPermissions
   * Number of Endpoints: 1
   * Endpoints: API_331_getRolePermissions
   ******************************************************************************/
  // Implementations:
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_331_getRolePermissions: {
    domain: 'TAGEndpoint',
    name: 'API_331_getRolePermissions',
    proxyName: 'customerPermissions',
    url: 'self-service-tpp-customerPermissions/v1/customers/{customerId}/accounts/{accountId}/roles',
    is_tag_proxy: true,
    // Reachability: unreachable
  },


  /******************************************************************************
   * ProxyName: assistedRepdash
   * Number of Endpoints: 10
   * Endpoints: API_2207_getAdjustmentAndFollowUps, API_357_postUpdateAdjustment, API_2208_postUpdateAdjustment, API_2209_postUpdateFollowUps, API_359_postReassignTickets, API_2210_postReassignTickets, API_2020_postSaveMemo, API_426_getRepDashUsageTable, API_433_mrcInfo, API_2200_getPeopleListForRep
   ******************************************************************************/
  // Implementations:
  // Services: experience/repdash/services/repdash.service.ts, support/account-shared/services/transaction-history.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2207_getAdjustmentAndFollowUps: {
    domain: 'TAGEndpoint',
    name: 'API_2207_getAdjustmentAndFollowUps',
    proxyName: 'assistedRepdash',
    url: 'self-service-tpp-assistedRepdash/v1/reps/adjustment-followup',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_357_postUpdateAdjustment: {
    domain: 'TAGEndpoint',
    name: 'API_357_postUpdateAdjustment',
    proxyName: 'assistedRepdash',
    url: 'self-service-tpp-assistedRepdash/v1/reps/update-adjustment',
    clearCache: true,
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2208_postUpdateAdjustment: {
    domain: 'TAGEndpoint',
    name: 'API_2208_postUpdateAdjustment',
    proxyName: 'assistedRepdash',
    url: 'self-service-tpp-assistedRepdash/v1/reps/update-adjustment',
    clearCache: true,
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2209_postUpdateFollowUps: {
    domain: 'TAGEndpoint',
    name: 'API_2209_postUpdateFollowUps',
    proxyName: 'assistedRepdash',
    url: 'self-service-tpp-assistedRepdash/v1/case/{caseId}',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_359_postReassignTickets: {
    domain: 'TAGEndpoint',
    name: 'API_359_postReassignTickets',
    proxyName: 'assistedRepdash',
    url: 'self-service-tpp-assistedRepdash/v1/case/status',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2210_postReassignTickets: {
    domain: 'TAGEndpoint',
    name: 'API_2210_postReassignTickets',
    proxyName: 'assistedRepdash',
    url: 'self-service-tpp-assistedRepdash/v1/reps/reassign-tickets',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2020_postSaveMemo: {
    domain: 'TAGEndpoint',
    name: 'API_2020_postSaveMemo',
    proxyName: 'assistedRepdash',
    url: 'self-service-tpp-assistedRepdash/v1/reps/save-memo-followup',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Services: experience/repdash/services/repdash.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_426_getRepDashUsageTable: {
    domain: 'TAGEndpoint',
    name: 'API_426_getRepDashUsageTable',
    proxyName: 'assistedRepdash',
    url: 'self-service-tpp-assistedRepdash/v1/rep-dash/usage-table',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_433_mrcInfo: {
    domain: 'TAGEndpoint',
    name: 'API_433_mrcInfo',
    proxyName: 'assistedRepdash',
    url: 'self-service-tpp-assistedRepdash/v1/customers/{customerId}/accounts/{accountId}/mrc-summary',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2200_getPeopleListForRep: {
    domain: 'TAGEndpoint',
    name: 'API_2200_getPeopleListForRep',
    proxyName: 'assistedRepdash',
    url: 'self-service-tpp-assistedRepdash/v1/case/refdata/teams',
    is_tag_proxy: true,
    // Reachability: unreachable
  },


  /******************************************************************************
   * ProxyName: assistedCancellation
   * Number of Endpoints: 2
   * Endpoints: API_424_getScheduledLineCancellations, API_425_getResumableLineCancellations
   ******************************************************************************/
  // Implementations:
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_424_getScheduledLineCancellations: {
    domain: 'TAGEndpoint',
    name: 'API_424_getScheduledLineCancellations',
    proxyName: 'assistedCancellation',
    url: 'self-service-tpp-assistedCancellation/v1/customers/{customerId}/accounts/{accountId}/cancellations/scheduled',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_425_getResumableLineCancellations: {
    domain: 'TAGEndpoint',
    name: 'API_425_getResumableLineCancellations',
    proxyName: 'assistedCancellation',
    url: 'self-service-tpp-assistedCancellation/v1/customers/{customerId}/accounts/{accountId}/cancellations/resumable',
    is_tag_proxy: true,
    // Reachability: unreachable
  },


  /******************************************************************************
   * ProxyName: assistedStateMgmt
   * Number of Endpoints: 2
   * Endpoints: API_428_saveAndLoadFavorite, API_430_removeFavourite
   ******************************************************************************/
  // Implementations:
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_428_saveAndLoadFavorite: {
    domain: 'TAGEndpoint',
    name: 'API_428_saveAndLoadFavorite',
    proxyName: 'assistedStateMgmt',
    url: 'self-service-tpp-assistedStateMgmt/v1/application-favorite, // 428 saveFavorit',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_430_removeFavourite: {
    domain: 'TAGEndpoint',
    name: 'API_430_removeFavourite',
    proxyName: 'assistedStateMgmt',
    url: 'self-service-tpp-assistedStateMgmt/v1/remove-favorite,    // 430 removeFavourit',
    is_tag_proxy: true,
    // Reachability: unreachable
  },


  /******************************************************************************
   * ProxyName: purchasePathAccount
   * Number of Endpoints: 1
   * Endpoints: API_484_getAccountInventory
   ******************************************************************************/
  // Implementations:
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_484_getAccountInventory: {
    domain: 'TAGEndpoint',
    name: 'API_484_getAccountInventory',
    proxyName: 'purchasePathAccount',
    url: 'self-service-tpp-purchasePathAccount/v1/service-agreements/{customerId}',
    is_tag_proxy: true,
    // Reachability: unreachable
  },


  /******************************************************************************
   * ProxyName: utility
   * Number of Endpoints: 3
   * Endpoints: API_515_sendEmail, API_550_postSurveyDetails, API_2725_clearAllFromActivityForActivityIds
   ******************************************************************************/
  // Implementations:
  // Services: support/activity-log/services/activity-log.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts, experience/order-summary/service/order-summary.service.ts
  API_515_sendEmail: {
    // twbdom-utility
    // POST
    // Onboarded
    domain: 'TAGEndpoint',
    name: 'API_515_sendEmail',
    proxyName: 'utility',
    url: 'self-service-tpp-utility/v1/sendEmail',
    is_tag_proxy: true
  },

  // Implementations:
  // Other files: core/api/proxies/assisted-api-endpoints.ts, experience/rep-survey/service/rep-survey.service.ts
  API_550_postSurveyDetails: {
    domain: 'TAGEndpoint',
    name: 'API_550_postSurveyDetails',
    proxyName: 'utility',
    url: 'self-service-tpp-utility/v1/surveydetails',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Services: support/shared/services/cache-manager.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2725_clearAllFromActivityForActivityIds: {
    domain: 'TAGEndpoint',
    name: 'API_2725_clearAllFromActivityForActivityIds',
    proxyName: 'utility',
    url: 'self-service-tpp-utility/v1/clearregion/clearAllFromActivityForActivityIds',
    is_tag_proxy: true,
    // Reachability: unreachable
  },


  /******************************************************************************
   * ProxyName: payment
   * Number of Endpoints: 1
   * Endpoints: API_519_getPaymentReferenceData
   ******************************************************************************/
  // Implementations:
  // Services: experience/shop/return-payment/services/return-payment.service.ts, support/payment/shared-payment/services/shared-payment.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_519_getPaymentReferenceData: {
    // twbdom-payment
    // POST
    // Onboarded
    domain: 'TAGEndpoint',
    name: 'API_519_getPaymentReferenceData',
    proxyName: 'payment',
    url: 'self-service-tpp-payment/v1/refundOptions',
    is_tag_proxy: true
  },


  /******************************************************************************
   * ProxyName: assistedCustomerManageProfile
   * Number of Endpoints: 3
   * Endpoints: API_523_checkCaseEligibility, API_526_balanceTransfer, API_2217_postCustomerRefundRequest
   ******************************************************************************/
  // Implementations:
  // Services: experience/refund-request/services/refund-request.service.ts, support/shared/services/override-modal.service.ts
  // Components: experience/billing-landing/components/pending-credits/pending-credits.component.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_523_checkCaseEligibility: {
    domain: 'TAGEndpoint',
    name: 'API_523_checkCaseEligibility',
    proxyName: 'assistedCustomerManageProfile',
    url: 'self-service-tpp-assistedCustomerManageProfile/v1/case/check-case',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Services: experience/billing-landing/services/transfer-payment-request.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_526_balanceTransfer: {
    domain: 'TAGEndpoint',
    name: 'API_526_balanceTransfer',
    proxyName: 'assistedCustomerManageProfile',
    url: 'self-service-tpp-assistedCustomerManageProfile/v1/financialaccount/balancetransfer',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Services: experience/refund-request/services/refund-request.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2217_postCustomerRefundRequest: {
    domain: 'TAGEndpoint',
    name: 'API_2217_postCustomerRefundRequest',
    proxyName: 'assistedCustomerManageProfile',
    url: 'self-service-tpp-assistedCustomerManageProfile/v1/refund-requests',
    is_tag_proxy: true,
    // Reachability: unreachable
  },


  /******************************************************************************
   * ProxyName: riskAssessment
   * Number of Endpoints: 1
   * Endpoints: API_2003_postEmailValidation
   ******************************************************************************/
  // Implementations:
  // Services: experience/shared-experience/services/email-verification.service.ts, experience/shop/cart/modules/account-setup/services/account-setup.service.ts, experience/shop/credit-check/services/credit-check.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2003_postEmailValidation: {
    // twbdom-risk-assessment
    // POST
    // Onboarded
    domain: 'TAGEndpoint',
    name: 'API_2003_postEmailValidation',
    proxyName: 'risk-assessment',
    url: 'self-service-tpp-risk-assessment/v1/customers/emailVerification',
    is_tag_proxy: true
  },


  /******************************************************************************
   * ProxyName: customer
   * Number of Endpoints: 4
   * Endpoints: API_2005_postSearchCustomers, API_2067_getSegmentationCompatibility, API_2068_updateAccountSegmentation, API_2069_updateCustomerSegmentation
   ******************************************************************************/
  // Implementations:
  // Services: support/shared/services/user.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2005_postSearchCustomers: {
    // twbdom-customer
    // POST
    // Onboarded
    domain: 'TAGEndpoint',
    name: 'API_2005_postSearchCustomers',
    proxyName: 'customer',
    url: 'self-service-tpp-customer/v1/customers/customerSummary/search',
    is_tag_proxy: true
  },

  // Implementations:
  // Services: experience/modules/manage-profile/segmentation/services/segmentation.services.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2067_getSegmentationCompatibility: {
    // twbdom-customer
    // POST
    // Onboarded
    domain: 'TAGEndpoint',
    name: 'API_2067_getSegmentationCompatibility',
    proxyName: 'customer',
    url: 'self-service-tpp-customer/v1/segmentationCompatibility',
    is_tag_proxy: true
  },

  // Implementations:
  // Services: experience/modules/manage-profile/segmentation/services/segmentation.services.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2068_updateAccountSegmentation: {
    domain: 'TAGEndpoint',
    name: 'API_2068_updateAccountSegmentation',
    proxyName: 'customer',
    url: 'self-service-tpp-customer/v1/updateAccountSegmentation',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Services: experience/modules/manage-profile/segmentation/services/segmentation.services.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2069_updateCustomerSegmentation: {
    domain: 'TAGEndpoint',
    name: 'API_2069_updateCustomerSegmentation',
    proxyName: 'customer',
    url: 'self-service-tpp-customer/v1/updateCustomerSegmentation',
    is_tag_proxy: true,
    // Reachability: unreachable
  },


  /******************************************************************************
   * ProxyName: assistedCustomer
   * Number of Endpoints: 3
   * Endpoints: API_2011_getDealerInfo, api_2014_getAvayaContext, API_2043_checkLineEligibility
   ******************************************************************************/
  // Implementations:
  // Services: experience/repdash/services/repdash.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2011_getDealerInfo: {
    domain: 'TAGEndpoint',
    name: 'api_2011_getDealerInfo',
    proxyName: 'assistedCustomer',
    url: 'self-service-tpp-assistedCustomer/v1/dealer-info/{dealerId}',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  api_2014_getAvayaContext: {
    domain: 'TAGEndpoint',
    name: 'api_2014_getAvayaContext',
    proxyName: 'assistedCustomer',
    url: 'self-service-tpp-assistedCustomer/v1/avaya-context/{uuid}',
    is_tag_proxy: true,
    // Reachability: unreachable
  },

  // Implementations:
  // Services: experience/shared-experience/services/change-line.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2043_checkLineEligibility: {
    domain: 'TAGEndpoint',
    name: 'API_2043_checkLineEligibility',
    proxyName: 'assistedCustomer',
    url: 'self-service-tpp-assistedCustomer/v1/account/lineeligibility',
    is_tag_proxy: true,
    // Reachability: unreachable
  },


  /******************************************************************************
   * ProxyName: assistedUtility
   * Number of Endpoints: 1
   * Endpoints: API_2015_dealerVerified
   ******************************************************************************/
  // Implementations:
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2015_dealerVerified: {
    domain: 'TAGEndpoint',
    name: 'API_2015_dealerVerified',
    proxyName: 'assistedUtility',
    url: 'self-service-tpp-assistedUtility/v1/dealerVerifiedEvent',
    is_tag_proxy: true,
    // Reachability: unreachable
  },


  /******************************************************************************
   * ProxyName: referenceList
   * Number of Endpoints: 1
   * Endpoints: API_2021_getRepDashLookupCriteria
   ******************************************************************************/
  // Implementations:
  // Services: experience/billing-landing/services/missing-payment-request.service.ts, experience/modules/manage-profile/segmentation/services/segmentation.services.ts, experience/negative-file-request/services/negative-file-request.service.ts, experience/refund-request/services/refund-request.service.ts, experience/shop/cart/modules/account-setup/services/account-setup.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts, experience/general-inquiry/service/general-inquiry.service.ts
  API_2021_getRepDashLookupCriteria: {
    // twbdom-reference-list
    // POST
    // Onboarded
    domain: 'TAGEndpoint',
    name: 'API_2021_getRepDashLookupCriteria',
    proxyName: 'reference-list',
    url: 'self-service-tpp-reference-list/v1/reference-list',
    is_tag_proxy: true
  },


  /******************************************************************************
   * ProxyName: cart
   * Number of Endpoints: 2
   * Endpoints: API_2131_getCartDetails, API_2803_updateProfileDetails
   ******************************************************************************/
  // Implementations:
  // Services: experience/cart-order-summary/services/cart-order-summary.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2131_getCartDetails: {
    // twbdom-cart
    // GET
    // Onboarded
    domain: 'TAGEndpoint',
    name: 'API_2131_getCartDetails',
    proxyName: 'cart',
    url: 'self-service-tpp-cart/v1/cart/{cartId}',
    is_tag_proxy: true
  },

  // Implementations:
  // Services: experience/shop/cart/modules/account-setup/services/account-setup.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2803_updateProfileDetails: {
    domain: 'TAGEndpoint',
    name: 'API_2803_updateProfileDetails',
    proxyName: 'cart',
    url: 'self-service-tpp-cart/v1/profiles/{profileId}',
    is_tag_proxy: true,
    // Reachability: unreachable
  },


  /******************************************************************************
   * ProxyName: document
   * Number of Endpoints: 1
   * Endpoints: API_2806_termsAndConditions
   ******************************************************************************/
  // Implementations:
  // Services: experience/shared-experience/services/terms-and-conditions.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2806_termsAndConditions: {
    domain: 'TAGEndpoint',
    name: 'API_2806_termsAndConditions',
    proxyName: 'document',
    url: 'self-service-tpp-document/v1/documents',
    is_tag_proxy: true,
    // Reachability: unreachable
  },


  /******************************************************************************
   * ProxyName: numberMgmt
   * Number of Endpoints: 1
   * Endpoints: API_2900_validateSim
   ******************************************************************************/
  // Implementations:
  // Services: experience/access-puk/services/puk.services.ts, experience/change-sim/services/change-sim.service.ts, support/cart-support/services/cart-support.service.ts, support/shared/services/byod-landing.service.ts
  // Other files: core/api/proxies/assisted-api-endpoints.ts
  API_2900_validateSim: {
    domain: 'TAGEndpoint',
    name: 'API_2900_validateSim ',
    proxyName: 'number-mgmt',
    url: 'self-service-tpp-number-mgmt/v1/devices/validate-SIM?SIMNumber={SIMNumber}',
    is_tag_proxy: true,
    // Reachability: unreachable
  },
};
